/**
 * MapMarker
 *
 * Renders out a MapMarker icon, an info box, and manages all the state (hover, etc) for it.
 */

// external dependencies
import React, { useState } from 'react'
import { bool, func, string } from 'prop-types'

// components
import { MapInfoBox } from './MapInfoBox'
import { MapMarkerIcon } from './MapMarkerIcon'

MapMarker.propTypes = {
	$hover: bool, // from google-map-react
	RenderMapInfoBox: func,
	RenderMapMarker: func,
	fillPrimary: string,
	fillSecondary: string,
	zIndex: string,
}

export function MapMarker({
	RenderMapInfoBox = MapInfoBox,
	RenderMapMarker = MapMarkerIcon,
	$hover,
	fillPrimary,
	fillSecondary,
	zIndex,
	...restOfProps
}) {
	/**
	 * Keep track of the pinned state of this marker. If it's pinned, keep the info window open and let the map
	 * marker size stay at the large size. In the future you can also act on this flag to add more functionality
	 * such as different background color, show more info in an expanded box, or change the underlying marker.
	 */
	const [isPinned, setIsPinned] = useState(false)

	const isExpanded = $hover || isPinned
	const fill = isPinned ? fillSecondary : fillPrimary
	const innerFill = isPinned ? fillPrimary : fillSecondary

	return (
		<>
			<RenderMapMarker
				fill={fill}
				innerFill={innerFill}
				isExpanded={isExpanded}
				onClick={() => setIsPinned(!isPinned)}
				zIndex={zIndex}
			/>
			{isExpanded && <RenderMapInfoBox onClick={() => setIsPinned(!isPinned)} {...restOfProps} />}
		</>
	)
}
